import React from 'react';
import ReactDOM from 'react-dom';
import {connect, Provider} from 'react-redux';
import {createStore, combineReducers} from 'redux';
import QueryString from 'qs';
import PromotionCode from '../components/PromotionCode';
import HiddenFields from '../components/HiddenFields';
import AccountInformation from '../components/AccountInformation';
import BookDetails from '../components/BookDetails';
import ContactInformation from '../components/ContactInformation';
import CourseInformation from '../components/CourseInformation';
import AgreeToTerms from '../components/AgreeToTerms';
import Submit from '../components/Submit';
import {Field, FieldArray, reduxForm, formValueSelector} from 'redux-form';
import {submit as submitAction} from '../redux/modules/submission';
import _ from 'lodash';
import moment from 'moment';

if (!Date.prototype.toSalesforceDate) {
    (function () {

        function pad(number) {
            if (number < 10) {
                return '0' + number;
            }
            return number;
        }

        Date.prototype.toSalesforceDate = function () {
            return this.getUTCFullYear() +
                '-' + pad(this.getUTCMonth() + 1) +
                '-' + pad(this.getUTCDate())
        };

    }());
}

function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

function submit(values_, noIdea, props) {
    let values = _.clone(values_);
    values['g-recaptcha-siteKey'] = props.options.recaptcha.siteKey;
    return new Promise((resolve, reject) => {
        // This is a bit gross, but we need to tweak the submitted form
        // values before sending them to the web service.
        if (props.product.onlinefulfillment) {
            // because we're no longer showing the terms and conditions checkbox for
            // online product fulfillments, we have to manually set it here because
            // the web service requires termsAndConditons be set.
            values.termsAndConditions = true;
        }
        if((values.office === "ca" || values.office === "us")){
          values.smsNotifications = !values.smsNotifications;
        }
        if (values.marketingEmail) {
            values.marketingPreference = 'Opt-In';
        }
        if (values.department === 'other') {
            // backend can't deal with 'other' department value...
            delete values.department;
        }
        values.useDepartmentAddress = (!values.useAlternateContact);
        if (values.useDepartmentAddress === false) {
            // backend can't deal with false useDepartmentAddress value...
            delete values.useDepartmentAddress;
        }
        values.enrollment = isNumeric(values.enrollment) ? Number.parseInt(values.enrollment) : '';
        if (values.office === 'uk' && values.opportunityType ==='New') {
            values.likelihoodOfAdoption = 'Product Positioning';
        }else if(values.office === 'uk' && values.opportunityType ==='Retain'){
            values.likelihoodOfAdoption = 'Decision';
        }else if(values.office === 'uk' && values.opportunityType ==='New Edition'){
            values.likelihoodOfAdoption = 'Product Positioning';
        }
         if((values.office === "ca" || values.office === "us")
         && (values.likelihoodOfAdoption === "75% chance I will choose this textbook" ||
             values.likelihoodOfAdoption === "I will adopt this text and I have <b><i>not</i></b> used it or a previous edition in the past" ||
             values.likelihoodOfAdoption === "50% chance I will choose this textbook")
            ){
                 values.opportunityType = 'New';
             }
         if((values.office === "ca" || values.office === "us") &&
         (values.likelihoodOfAdoption === "I will adopt this text and I have used it or a previous edition in the past")){
                 values.opportunityType = 'Retain';
         }
        if((values.office === "ca" || values.office === "us") && values.likelihoodOfAdoption === "50% chance I will choose this textbook"){
          values.likelihoodOfAdoption = 'Product Positioning';
        }else  if((values.office === "ca" || values.office === "us") && values.likelihoodOfAdoption !== "50% chance I will choose this textbook"){
          values.likelihoodOfAdoption = 'Decision';
        }
        if (!values.country && values.office === 'uk'&& values.nextSemMonth && values.nextSemYear) {
            //var d = new Date( values.nextSemYear, values.nextSemMonth, 1 );
            //values.moduleStartDate = d.toSalesforceDate();
            values.country = 'GB'; // XXX
            values.nextSemesterOffered = values.nextSemMonth + ' ' + values.nextSemYear;
        } else if (values.nextSemMonth && values.nextSemYear) {
            values.nextSemesterOffered = values.nextSemMonth + ' ' + values.nextSemYear;
        }
        //delete values.nextSemMonth;
        //delete values.nextSemYear;
        fetch(`${props.options.ws.base}/api/v1/${values.office}/orders`,
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify(values)
            })
            .then(function (response) {
                if (response.status !== 500) {
                    return response.json();
                } else {
                    return new Promise((resolve, reject) => {
                        response.text().then(txt => {
                            try {
                                txt = JSON.parse(txt);
                                resolve(txt);
                            } catch (e) {
                                resolve({
                                    ...response,
                                    body: txt
                                })
                            }
                        }).catch(ex => {
                            reject(ex);
                        })
                    });
                }
            })
            .then(function (json) {
                props.dispatch(submitAction(json));
                resolve(json);
            })
            .catch(function (ex) {
                reject(ex);
                console.log(ex);
            });
    });
}

class ErrorMessages extends React.Component {
    render() {
        if (this.props.response) {
            const darkRedText = {color: '#c00', backgroundImage: 'none'};
            const lightPinkBackground = {backgroundColor: '#fee'};
            Object.assign(darkRedText, lightPinkBackground);
            if (this.props.response.errorFields && this.props.response.errorFields) {
                var errors = this.props.response.errorFields;
                if (errors && errors.length > 0) {
                    return (
                        <fieldset style={lightPinkBackground}>
                            <legend style={darkRedText}>Error</legend>
                            <div className="gratisBookDetails">
                                <h4 style={darkRedText}>Fields marked with a * are required to process your
                                    request.</h4>
                            </div>
                        </fieldset>
                    )
                }
            } else if (this.props.response.message) {
                let message = this.props.office.config.rejectedRequestMessage;
                return (
                    <div className="messages">
                        <div className="tileerror" id="clientsuccess">
                            <div className="tileerrortop">
                            <i className="fa fa-warning" style={{color: 'red'}}/>
                                <b>&nbsp;Error</b></div>
                            <ul className="tileerrorbottom">
                                <li className="successsiteusermessage" dangerouslySetInnerHTML={{__html: message}}>
                                </li>
                            </ul>
                        </div>
                    </div>

                )
            } else {
                return null;
            }
        } else {
            return null;
        }
    }

    componentDidMount() {
        this.ensureVisible();
    }

    componentDidUpdate() {
        this.ensureVisible();
    }

    ensureVisible() {
        if (this.props.response) {
            var errors = this.props.response.errorFields;
            if (errors && errors.length > 0) {
                var n = ReactDOM.findDOMNode(this);
                if (n) {
                    n.scrollIntoView();
                }
            }
        }
    }
}

class DuplicateMessage extends React.Component {
    componentDidMount() {
        this.ensureVisible();
    }

    componentDidUpdate() {
        this.ensureVisible();
    }

    ensureVisible() {
        var n = ReactDOM.findDOMNode(this);
        if (n) {
            n.scrollIntoView();
        }
    }

    render() {
        const props = this.props;
        let message;
        if (props.response.message === 'Recent Opportunity') {
            message = props.office.config.recentOpportunityMessage;
        } else if (props.response.message === 'Recent Lead') {
            message = props.office.config.recentLeadMessage;
        } else {
            message = props.office.config.duplicateRequestMessage;
        }
        return (
            <div className="messages">
                <div className="tileerror" id="clientsuccess">
                    <div className="tileerrortop">
                     <i className="fa fa-warning" style={{color: "red"}}/>
                        <b>&nbsp;Error</b></div>
                    <ul className="tileerrorbottom">
                        <li className="successsiteusermessage" dangerouslySetInnerHTML={{__html: message}}>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

class SuccessMessage extends React.Component {
    componentDidMount() {
        this.ensureVisible();
    }

    componentDidUpdate() {
        this.ensureVisible();
    }

    ensureVisible() {
        var n = ReactDOM.findDOMNode(this);
        if (n) {
            n.scrollIntoView();
        }
    }

    render() {
        const props = this.props;
        let message;
        let created = props.response.lead || props.response.opportunity;
        if (!(created && created.id)) {
            message = props.office.config.rejectedRequestMessage;
        } else if (props.product.onlinefulfillment) {
            message = props.office.config.successMessage_online;
        } else {
            message = props.office.config.successMessage;
        }
        let {officeValue} = this.props.office.code;
        const renderAdestra = ()=>{
            if(officeValue == 'us'){
              return <div>
              <img src='https://oup.msgfocus.com/v/?tag=&quot;us he inspection request &quantity=1&cache_time=30' width="1" height="1"/>
            </div>
            }else{
               return <div>
              <img src='https://oup.msgfocus.com/v/?tag=uk he inspection request &quantity=1&cache_time=30' width="1" height="1"/>
            </div>
            }
        };
        return (
            <div className="messages">
                <div className="tileerror" id="clientsuccess">
                    <div className="tileerrortop">
                    <i className="fa fa-check" style={{color: "green"}}/>
                        &nbsp;Success
                        
                    </div>
                    <ul classNam="tileerrorbottom">
                        <li className="successsiteusermessage" dangerouslySetInnerHTML={{__html: message}}>
                        </li>
                    </ul>
                </div>
                {renderAdestra()}
            </div>
        );
    }
}

let GratisForm = (props) => {
    const {
        handleSubmit, load, pristine, reset, submitting, product, office,
        formValues: {department, departmentName}
    } = props;
    const errorStyle = props.errorStyle.bind({props});
    const showAcctInfo = office && office.config && product && !product.error;
    const showForm = showAcctInfo && ((department && department !== 'other') || departmentName);
    const errorFields = [];
    let created;
    if (props.response) {
        // { "status": 500, "message": "Recent Opportunity", "error": {} }
        created = props.response.lead || props.response.opportunity;
        if (props.response.errors) {
            _.each(props.response.errors, (e) => {
                _.each(e, (v, k) => {
                    errorFields.push(k);
                })
            });
            props.response.errorFields = errorFields;
        } else if (props.response.body) {
            props.response.message = props.response.body;
        } else if (false && created) {
            props.response.message = JSON.stringify(created, null, 2);
        }
    }
    let msg = null;
    let submitted = false;

    if (created) {
        submitted = true;
        if (!created.duplicate__c) {
            if (props.options && props.options.message && props.options.message.success
                && _.isFunction(props.options.message.success)) {
                msg = null;
                props.options.message.success({created, ...props});
            }
            else {
                msg = <SuccessMessage {...props}/>
            }
        } else {
            msg = <DuplicateMessage {...props}/>
        }
    } else if (props.response.status == 500) {
        submitted = true;
        //msg = <DuplicateMessage {...props}/>
        msg = <ErrorMessages errorStyle={errorStyle} {...props}/>
    } else {
        msg = <ErrorMessages errorStyle={errorStyle} {...props}/>
    }
    if (!props.params.dev && submitted) {
        return msg;
    } else {
        return (
            <form onSubmit={handleSubmit(submit)}>
                {msg}
                <BookDetails errorStyle={errorStyle}/>
                <AgreeToTerms errorStyle={errorStyle} visible={showAcctInfo}/>
                <AccountInformation errorStyle={errorStyle} visible={showAcctInfo}/>
                <CourseInformation errorStyle={errorStyle} visible={showForm}/>
                <ContactInformation errorStyle={errorStyle} visible={showForm}/>
                <Submit errorStyle={errorStyle} visible={showForm}/>
            </form>
        );
    }
};


const formName = 'gratisForm';  // XXX: hardcoded form name!

// Decorate with reduxForm(). It will read the initialValues prop provided by connect()
GratisForm = reduxForm({
    form: formName
})(GratisForm);

const selector = formValueSelector(formName);

GratisForm = connect(
    state => ({
        product: state.product,
        office: state.office,
        response: state.response,
        formValues: selector(state, 'department', 'departmentName', 'g-recaptcha-response')
    })
)(GratisForm);

export default GratisForm;



// WEBPACK FOOTER //
// ./src/form/containers/GratisForm.js